import router from './routers'
export default {
  addRouter (menus) {
    //动态添加路由
    menus.forEach((ele) => {
      if (ele.url != null && ele.url.startsWith('/')) {
        let r = {
          path: ele.url,
          component: () => import('../components' + ele.url + '.vue')
        }
        router.options.routes[2].children.push(r)
        router.addRoutes(router.options.routes)
      }
    })
  }
}